/** @jsxImportSource @emotion/react */

import Image from 'next/image';

import { media } from '@stories/theming/settings';
import imageLoader from '@utils/imageLoader';

import { ExclusiveBrands } from './ExclusiveBrands';
import { SectionHeader, section } from './VitafyAboutUsPage';

const logos = [
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/Weider.svg',
    alt: 'Logo Weider'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/optimum-nutrition9401.svg',
    alt: 'Logo Optimum Nutrition'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/Brand-shop_Powerbar.svg',
    alt: 'Logo Powerbar'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/NOCCO_text_logo.svg.svg',
    alt: 'Logo Nocco'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/1200px-Rapunzel_Naturkost.svg.svg',
    alt: 'Logo Rapunzel'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/Brand-shop_Barebells.svg',
    alt: 'Logo Barebells'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/Brand-shop_Olimp.svg',
    alt: 'Logo Olimp'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/Brand-shop_EgmontHoney.svg',
    alt: 'Logo Egmont Honey'
  },
  {
    url: 'https://cdn11.vitafy.de/vitafy/image/upload/vitafy/about-us/Vielseitigkeit/BK_Barbara-Klein_Logo_positiv.svg',
    alt: 'Logo Barbara Klein'
  }
];

export const LogoGrid: React.FC = () => {
  return (
    <div>
      <ul
        css={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '1rem .5rem',
          justifyContent: 'space-evenly',
          marginBottom: '2rem',
          marginTop: '3rem',
          [media('desktop')]: { marginTop: '5rem', marginBottom: '4rem' }
        }}
      >
        {logos.map((logo) => (
          <li key={logo.url} css={{ display: 'block', width: '200px', position: 'relative' }}>
            <Image
              loader={imageLoader}
              // @ts-expect-error static important
              css={{ height: 'auto !important', position: 'static !important' }}
              src={logo.url}
              alt={logo.alt}
              fill
              unoptimized={logo.url.endsWith('.svg')}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export const Variety: React.FC = () => {
  const subtitle = `
              <p>
              Entdecke über
              <span style="font-weight: bold">5000 sorgfältig ausgewählte Produkte führender Marken</span> 
              aus den Bereichen Fitness, Gesundheit, Ernährung und Wellness. Unsere Produkte bieten das 
              <span style="font-weight: bold">beste Preis-Leistungs-Verhältnis</span> und unterstützen dich
              dabei, deine Ziele zu erreichen und ein gesünderes, vitaleres Leben zu führen.
            </p>`;
  return (
    <section css={{ backgroundColor: 'hsl(198 42% 95%)', paddingBottom: '3rem' }}>
      <svg
        viewBox="0 0 100 11"
        xmlns="http://www.w3.org/2000/svg"
        css={{ display: 'block', height: 'auto', width: '100%' }}
      >
        <path d="M0 0 L100 0 L50 11 Z" fill="white" />
      </svg>
      <article css={{ ...section, [media('desktop')]: { padding: '5rem var(--offset) 2rem' } }}>
        <SectionHeader title="Vielseitigkeit" subtitle={subtitle} />
        <LogoGrid />
      </article>
      <article css={{ marginTop: '4rem', ...section }}>
        <ExclusiveBrands />
      </article>
    </section>
  );
};
